import { NgModule } from '@angular/core';
import { reducer } from './entities-reducer';
import { StoreModule } from '@ngrx/store';
import { StateSlice } from '@core/state/state-slice';
import { initialEntitiesState } from './entities-state';
import { combineReducers } from '@core/utils/state';

@NgModule({
    imports: [
        StoreModule.forFeature(StateSlice.ENTITY, reducer, {
            initialState: initialEntitiesState(),
            reducerFactory: combineReducers
        })
    ],
    declarations: []
})
export class EntityStateModule {
}
